if (!customElements.get('kvr-products')) {
  customElements.define('kvr-products', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-kvr-products-grid]');
      this.fill = this.querySelector('[data-kvr-products-progress]');

      this.revealObserver = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        this.classList.add('is-visible');
        this.revealObserver.disconnect();
      }, { threshold: 0.12 });
      this.revealObserver.observe(this);

      if (this.grid && this.fill) {
        this.onGridScroll = this.updateProgress.bind(this);
        this.grid.addEventListener('scroll', this.onGridScroll, { passive: true });
        window.addEventListener('resize', this.onGridScroll, { passive: true });
        this.updateProgress();
      }
    }

    updateProgress() {
      const maxScroll = this.grid.scrollWidth - this.grid.clientWidth;
      const visibleShare = this.grid.clientWidth / this.grid.scrollWidth;
      const travelledShare = maxScroll > 0 ? (this.grid.scrollLeft / maxScroll) * (1 - visibleShare) : 0;
      this.style.setProperty('--kvr-products-progress', `${Math.min(100, (visibleShare + travelledShare) * 100)}%`);
    }

    disconnectedCallback() {
      if (this.revealObserver) this.revealObserver.disconnect();
      if (this.grid && this.onGridScroll) this.grid.removeEventListener('scroll', this.onGridScroll);
      window.removeEventListener('resize', this.onGridScroll);
    }
  });
}
